import Newsletter from "@components/Newsletter/Newsletter";
import StateView from "@components/StateView/StateView";
import VoucherSlider from "@components/vocher/vocherSlider";
import VoucherController from "@controller/voucher/voucherController";
import Sectioncomminity from "@frontpage/section_comminity";
import BaseLayout from "@layout/base-layout";
import style from "@styles/main.module.css";
import classNames from "classnames";
import { observer } from "mobx-react";
import { NextSeo } from "next-seo";
import Link from "next/link";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  PersonalitySvg,
  SupportSvg,
  WeightSvg,
} from "../../components/ui/VoucherIcons";
import useWindowSize from "src/hooks/useWindowSize";

const controller = new VoucherController();
const Voucher = observer((props) => {
  const [isPlay, setIsPlay] = useState(false);
  const { t } = useTranslation("common");
  const refVideo = useRef();
  const { width } = useWindowSize();
  const isMobile = width < 600;

  useEffect(() => {
    controller.getData();
  }, []);

  const _videoAction = (status) => {
    if (status) {
      refVideo.current.controls = true;
    } else {
      refVideo.current.controls = false;
    }
  };

  return (
    <div>
      <NextSeo
        title={t("tag.voucher_meta_title")}
        description={t("tag.voucher_meta_description")}
        canonical={`${process.env.NEXT_PUBLIC_SITE_ADDRESS}voucher`}
        openGraph={{
          url: `${process.env.NEXT_PUBLIC_SITE_ADDRESS}voucher`,
          title: `${t("tag.voucher_meta_title")}`,
          description: `${t("tag.voucher_meta_description")}`,
          site_name: "Moverii",
        }}
        twitter={{
          handle: "@handle",
          site: "@site",
          cardType: "summary_large_image",
        }}
      />
      <main className="w-full">
        <section className="w-full ">
          <div className="bg-[url(/static/images/VoucherSample.jpg)] bg-cover bg-center py-28">
            <h1 className="mx-auto w-full !container md:text-[40px] text-2xl text-white lg:px-0 px-5 md:mx-8 md:text-left text-center catamaran leading-10 font-[900]">
              {t("voucher.main_text1")}
              <br />
              {t("voucher.main_text2")}
            </h1>
          </div>
        </section>
        <div className={"container"}>
          <section className="w-full space-y-3 py-10  md:px-0 px-5 text-base font-normal azo">
            <p>{t("voucher.main_text3")}</p>
            <p>{t("voucher.main_text4")}</p>
            <p>{t("voucher.main_text5")}</p>
          </section>
          <section className="w-full md:px-0 px-5 ">
            <div className=" flex w-full mb-5 flex-col items-start justify-center">
              <h2 className="text-[28px] font-bold leading-5 text-[#212121]">
                {t("voucher.main_text6")}
              </h2>
              <p className="text-base font-normal azo text-[#212121] mt-3">
                {t("voucher.main_text7")}
              </p>
            </div>
          </section>
        </div>
        <div className={"container mt-4"}>
          <StateView state={controller.stateView}>
            <VoucherSlider data={controller.list} />
          </StateView>
        </div>
        <section className="w-full bg-[#FDD59E] mt-[50px] px-10 lg:px-0 ">
          <div className="mx-auto !container grid md:grid-cols-3 grid-cols-1 md:space-y-0 space-y-10 items-start justify-items-center gap-x-10 lg:gap-x-28 py-16">
            <article className="flex w-full flex-col items-center justify-center gap-y-4">
              <WeightSvg />
              <h2 className="m-0 text-lg font-bold leading-5 text-[#212121] text-center">
                {t("voucher.main_text8")}
              </h2>
              <p className="m-0 lg:-mt-2 text-center text-base font-normal azo text-[#212121]">
                {t("voucher.main_text9")}
              </p>
            </article>
            <article className="flex w-full flex-col items-center justify-center gap-y-4">
              <PersonalitySvg />
              <h2 className="m-0 text-lg font-bold leading-5 text-[#212121] text-center">
                {" "}
                {t("voucher.main_text10")}
              </h2>
              <p className="m-0 lg:-mt-2 text-center text-base font-normal azo text-[#212121]">
                {t("voucher.main_text11")}
              </p>
            </article>
            <article className="flex w-full flex-col items-center justify-center gap-y-4">
              <SupportSvg />
              <h2 className="m-0 text-lg font-bold leading-5 text-[#212121] text-center">
                {t("voucher.main_text12")}
              </h2>
              <p className="m-0 lg:-mt-2 text-center text-base font-normal azo text-[#212121]">
                {t("voucher.main_text13")}
              </p>
            </article>
          </div>
        </section>
        <section className="w-full !container lg:px-5">
          <div className="mx-auto mt-[110px] grid w-full lg:grid-cols-2 grid-cols-1 items-center justify-items-center lg:gap-x-10 px-0 md:gap-y-20 lg:gap-y-0">
            <div className="relative h-full w-full px-7 md:px-5 lg:px-0 mb-10 md:mb-0">
              <div
                className={classNames(
                  style.video_exp_box,
                  "flex w-full lg:mr-10 max-h-[25rem] justify-center rounded-2xl"
                )}
              >
                <div
                  className={classNames(
                    style.play_exp_box,
                    "flex justify-center"
                  )}
                >
                  <div className={style.play_icon}>
                    <img className={style.ds1} src="/main/ds1.svg" />
                    <img
                      src="/static/images/ds2.svg"
                      className={classNames(style.ds2)}
                    />
                  </div>
                </div>

                {!isPlay && (
                  <div
                    className={"play-buttom cursor-pointer flex self-center"}
                  >
                    <div
                      className={classNames("flex play-buttom-inner")}
                      onClick={() => refVideo.current.play()}
                    >
                      <img src="/static/images/play.svg" alt="play" />
                    </div>
                  </div>
                )}
                <video
                  poster="https://trello.com/1/cards/638f747d93ea0e040c995244/attachments/6465f0f249644b333eb2dd2b/download/moverii-Gutschein_Ausdruck-Verschenken.jpg"
                  onPlaying={() => {
                    setIsPlay(true);
                  }}
                  onPause={() => {
                    setIsPlay(false);
                  }}
                  onMouseEnter={() => _videoAction(true)}
                  onMouseLeave={() => _videoAction(false)}
                  ref={refVideo}
                  className={
                    "w-full max-h-[24rem] h-[24rem] max-h-fit rounded-2xl w-full object-cover flex self-center"
                  }
                >
                  <source
                    className={"h-[24rem]"}
                    src={
                      "https://videostrim.s3.eu-central-1.amazonaws.com/homepage.mp4"
                    }
                    type="video/mp4"
                  />
                </video>
              </div>
            </div>
            <div className="flex h-full w-full md:px-0 px-5 flex-col items-start justify-center">
              <h2 className="text-[28px] font-bold leading-8 text-[#212121] mb-5">
                {isMobile ? (
                  <span>
                    {t("voucher.main_text14")} {t("voucher.main_text15")}
                  </span>
                ) : (
                  <span>
                    {t("voucher.main_text14")}
                    <br />
                    {t("voucher.main_text15")}
                  </span>
                )}
              </h2>
              <p className="text-base font-normal azo text-[#212121]">
                {t("voucher.main_text16")}
                <br />
                <br />
                {t("voucher.main_text17")}
                <br />
                <br />
                {t("voucher.main_text18")}
                <br />
                <br />
                {t("voucher.main_text19")}
              </p>
            </div>
          </div>
        </section>
        <section className="w-full md:px-0 px-5 mt-[100px] !container">
          <div className="mx-auto flex w-full  flex-col items-start justify-center gap-y-5 rounded-[1.25rem] bg-[url(https://api.moverii.de/cdn/statics/Voucher/Sport-Aktivreisen_moverii.jpg)] bg-cover bg-center p-11 relative">
            <span
              className={
                "bg-gradient-to-r from-black to-transparent via-transparent absolute left-0 right-0 top-0 bottom-0 z-0 rounded-2xl"
              }
              style={{
                background:
                  "linear-gradient(90deg,rgba(0,0,0,.7),hsla(0,0%,100%,0))",
              }}
            />
            <h2 className="text-[28px] font-bold leading-5 text-white z-50">
              {t("voucher.main_text20")}
            </h2>
            <p className="md:max-w-[50%] text-base font-normal azo text-white z-50">
              {t("voucher.main_text21")}
            </p>
            <Link href={"/tripfinder"}>
              <a
                href={"/tripfinder"}
                className="rounded-[1.25rem] bg-[#FF9F1C] px-8 py-3 text-base font-semibold !text-white z-50"
              >
                {t("voucher.main_text22")}
              </a>
            </Link>
          </div>
        </section>
        <Newsletter
          image1={"/static/images/news.png"}
          image2={
            process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
            "cdn/statics/Newsletter-Element/Aktivurlaub_moverii.jpg"
          }
          image3={
            process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
            "cdn/statics/Newsletter-Element/Yoga-Retreats_moverii.jpg"
          }
          title={t("contact.newsletter_title")}
          description={t("contact.newsletter_description")}
          inputPlaceholder={t("contact.newsletter_placeholder")}
          buttonTitle={t("contact.newsletter_button")}
        />
        <div className="!mb-[80px]">
          <Sectioncomminity mode={"white"} />
        </div>
      </main>
    </div>
  );
});
Voucher.Layout = BaseLayout;

export default Voucher;
